import React from 'react';
import isNil from '~/_base/functions/isNil';
import IconButton from '@mui/material/IconButton';
import Feed from '../components/feed';
import FeedFilters from '../components/feedFilters';
import FeatureMap from '../components/featureMap';
import ZoomableChart from '../components/zoomableChart';
import { ILoader, IFilter, IFilterActive } from '~/_base/components/helixIcons';

export default class Layout extends React.Component {
  constructor() {
    super();

    this.state = {
      open: false,
      loaded: false,
    };
  }

  // componentDidMount() {
  //
  //     this.setState({
  //         loaded: true
  //     })
  // }

  render() {
    const { anchor, open } = this.state;
    const dataClassName = 'feedContainer';

    if (!this.props.initialised) {
      return (
        <ILoader fontSize="large" />
      );
    }

    //

    return (
      <div id="liveViewContainer">
        <div className={dataClassName}>
          <div className="filterBtnContainer">
            <IconButton
              sx={{ float: 'right' }}
              onClick={() => this.handleDrawerToggle()}
              size="large">
              {this.props.filters.set ? <IFilterActive /> : <IFilter /> }
            </IconButton>
          </div>

          <Feed
            getting={this.props.gettingFeed}
            data={this.props.feedData}
            actions={this.props.actions}
            feedDataSelectedIndex={this.props.feedDataSelectedIndex}
          />
        </div>
        <FeedFilters
          filters={this.props.filters}
          open={this.state.open}
          projectId={this.props.projectId}
          handleClose={() => this.handleDrawerToggle()}
          actions={this.props.actions}
        />
        <div className="mapContainer">
          {!isNil(this.props.boundingRectangle) ? (
            <FeatureMap
              projectId={this.props.projectId}
              getting={this.props.gettingMap}
              mapData={this.props.mapData}
              actions={this.props.actions}
              boundingRectangle={this.props.boundingRectangle}
            />
          ) : null}
          <div className="timeSelectorContainer">
            {this.props.renderChart ? (
              <ZoomableChart
                projectId={this.props.projectId}
                getting={this.props.gettingChart}
                actions={this.props.actions}
                eventActivity={this.props.eventActivity}
                eventStart={this.props.eventStart}
                eventEnd={this.props.eventEnd}
                filters={this.props.filters}
                renderChart={this.props.renderChart}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  handleDrawerToggle() {
    this.setState({
      open: !this.state.open,
    });
  }
}
